// extracted by mini-css-extract-plugin
module.exports = {"container":"ImportDetailPage_container__2GYBt","imagesContainer":"ImportDetailPage_imagesContainer__3GY7R","productImage":"ImportDetailPage_productImage__bhgg4"};